import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

const AppModal = ({
  show,
  onHide,
  onExited,
  onSubmit,
  heading,
  subheading,
  submitting = false,
  submitDisabled = false,
  submitLabel = 'Submit',
  children,
  showCancelButton = true,
  showFooter = true,
  cancelButtonVariant = 'outline-secondary',
  submitButtonVariant = 'primary-new',
  size,
  dialogClassName,
  bodyClassName = '',
  /** Keep mounted but hide dialog/backdrop (e.g. while a nested modal is open). */
  visuallyHidden = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      onExited={onExited}
      centered
      backdrop={visuallyHidden ? false : 'static'}
      enforceFocus={!visuallyHidden}
      restoreFocus={!visuallyHidden}
      size={size}
      className={visuallyHidden ? 'd-none' : undefined}
      dialogClassName={dialogClassName}
      contentClassName="app-modal-content"
    >
      <Modal.Header closeButton={!submitting}>
        <Modal.Title>
          <div>{heading}</div>
          {subheading && (
            <div className="smallFont">
              <span className="text-muted mr-1">for </span>
              <span className="font-weight-semibold">{subheading}</span>
            </div>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={`app-modal-body ${bodyClassName}`}>{children}</Modal.Body>

      {showFooter && (
        <Modal.Footer className="app-modal-footer">
          {showCancelButton && (
            <Button variant={cancelButtonVariant} onClick={onHide} disabled={submitting} style={{ boxShadow: 'none' }}>
              Cancel
            </Button>
          )}
          <Button
            variant={submitButtonVariant}
            className="font-weight-bold px-4 d-inline-flex align-items-center justify-content-center"
            disabled={submitting || submitDisabled}
            onClick={onSubmit}
          >
            {submitting && <Spinner size="sm" animation="border" className="mr-1" />}
            {submitLabel}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default AppModal;
